'use client';

import { usePublicProfile, useTraderStats, useUserStats } from '@/services/query';
import { getMonthAbbr } from '@/utils';

/**
 * Custom hook to manage the state and logic for the Leaderboard Portfolio page.
 */
export const useLeaderboardPortfolio = (id: string) => {
  // --- 1. Data Fetching ---
  const { data: profile, isLoading: isProfileLoading } = usePublicProfile(
    id,
    {},
    { enabled: !!id }
  );
  const { data: userStats, isLoading: isUserStatsLoading } = useUserStats(id, { enabled: !!id });
  const { data: traderStats } = useTraderStats({ user: id, limit: 1 }, { enabled: !!id });

  // --- 2. Business Logic Helpers ---
  // Format joined date: "Joined MMM YYYY"
  const formattedJoinedDate = profile?.createdAt
    ? `${getMonthAbbr(profile.createdAt)} ${new Date(profile.createdAt).getFullYear()}`
    : 'Dec 2025';

  return {
    state: {
      profile,
      userStats,
      traderStats,
      isProfileLoading: isProfileLoading || isUserStatsLoading,
      formattedJoinedDate,
    },
    handlers: {},
  };
};

export default useLeaderboardPortfolio;
